import { connect } from 'react-redux'
import { selectors } from '../reducers/index.js'
import Redirector from '../components/Redirector.jsx'

const mapStateToProps = (state, props) => {
  const { url, wait, message } = selectors.selectRedirection(state)

  // if you want to see what the redirector looks like, you can temporarily
  // show it by changing the if condition to true
  if (false) {
    return {
      url: 'https://timetoast.com',
      wait: 200000,
      message: 'Please wait while we redirect you',
      ...props,
    }
  } else {
    return {
      url: url,
      wait: wait,
      message: message,
      // allows overriding the props from store by directly setting props
      // on container component
      ...props,
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Redirector)
